module.exports = __webpack_public_path__ + "img/eventKakaoFriend0428.02805f23.jpg";